import React from 'react';
import HeroSlider from '../components/HeroSlider';
import AwardsSection from '../components/AwardsSection';
import BestImagesSection from '../components/BestImagesSection';
import ArtistProfile from '../components/ArtistProfile';
import ContactSection from '../components/ContactSection';

const HomePage = () => {
  React.useEffect(() => {
    // Check if there's a hash in the URL and scroll to it
    if (window.location.hash) {
      const id = window.location.hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        // Delay slightly to allow content to render
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, []);

  return (
    <div>
      <HeroSlider />

      {/* Section Divider */}
      <div className="border-t border-gray-200"></div>

      <AwardsSection />

      {/* Section Divider */}
      <div className="border-t border-gray-200"></div>

      <BestImagesSection />

      {/* Section Divider */}
      <div className="border-t border-gray-200"></div>

      <ArtistProfile />

      {/* Section Divider */}
      <div className="border-t border-gray-200"></div>

      <ContactSection />
    </div>
  );
};

export default HomePage;
